import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Box, Tabs } from 'stylist'
import withUser from 'components/withUser'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import RelationshipContainer from 'components/RelationshipContainer'
import fields from 'fields/users'
import { get } from 'utils/api'
import RouteUserCompanies from 'routes/admin/users/companies'
import RouteUserCompaniesNew from 'routes/admin/users/companies/new'
import RouteUserCompaniesManage from 'routes/admin/users/companies/manage'
import RouteUserProducts from 'routes/admin/users/products'
import RouteUserServers from 'routes/admin/users/servers'
import RouteServersManage from 'routes/admin/users/servers/manage'
import renderValue from 'utils/renderValue'

const RouteShow = ({ user, match: { path }, refetch }) => {
  const [generatedLinks, setGeneratedLinks] = useState({
    set_link: null,
    reset_link: null,
  })

  useEffect(() => {
    get(`/users/${user.id}/reset-password`).then(setGeneratedLinks)
  }, [user.id])

  const fieldsForDisplay = useMemo(() => {
    const emailIndex = fields.findIndex((field) => field.name === 'email')

    if (emailIndex === -1) return fields

    const left = fields.slice(0, emailIndex + 1)
    const right = fields.slice(emailIndex + 1)

    return [
      ...left,
      { name: 'set_link', label: 'Registration Link' },
      { name: 'reset_link', label: 'Reset Password Link' },
      ...right,
    ]
  }, [])

  const userDetails = {
    ...user,
    set_link: generatedLinks.set_link,
    reset_link: generatedLinks.reset_link,
  }

  return (
    <Fragment>
      <h5>User Information</h5>
      <Box>
        <Box.Item pad>
          {fieldsForDisplay.map((field) => (
            <InfoGroup key={field.name}>
              <Subheader>{field.label || field.name}:</Subheader>
              {['set_link', 'reset_link'].includes(field.name) && userDetails[field.name] ? (
                <a
                  href={userDetails[field.name]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {userDetails[field.name]}
                </a>
              ) : (
                <span>{renderValue(userDetails[field.name])}</span>
              )}
            </InfoGroup>
          ))}
        </Box.Item>
      </Box>
      <Tabs>
        <Tabs.Item to={`${path}/companies`}>Companies</Tabs.Item>
        <Tabs.Item to={`${path}/servers`}>Servers</Tabs.Item>
        <Tabs.Item to={`${path}/products`}>Products</Tabs.Item>
      </Tabs>
      <RelationshipContainer>
        <Switch>
          <Route
            path={`${path}/companies`}
            exact
            render={(routeProps) => (
              <RouteUserCompanies
                variables={{ user_id: user.id }}
                {...routeProps}
              />
            )}
          />
          <Route
            path={`${path}/companies/new`}
            exact
            render={(routeProps) => (
              <RouteUserCompaniesNew user={user} refetch={refetch} {...routeProps} />
            )}
          />
          <Route
            path={`${path}/companies/manage`}
            exact
            render={(routeProps) => (
              <RouteUserCompaniesManage
                user={user}
                variables={{ user_id: user.id, show_has_user: true }}
              />
            )}
          />
          <Route
            path={`${path}/servers`}
            exact
            render={(routeProps) => (
              <RouteUserServers
                variables={{ user_id: user.id }}
                {...routeProps}
              />
            )}
          />
          <Route
            path={`${path}/servers/manage`}
            exact
            render={() => (
              <RouteServersManage
                user={user}
                variables={{ user_id: user.id, show_has_user: true }}
              />
            )}
          />
          <Route
            path={`${path}/products`}
            exact
            render={(routeProps) => (
              <RouteUserProducts
                variables={{ user_id: user.id }}
                {...routeProps}
              />
            )}
          />
        </Switch>
      </RelationshipContainer>
    </Fragment>
  )
}

export default withUser(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/users/show.js